import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Typography,
  useTheme,
} from "@mui/material";
import api from "../api/api";
import AuthLayout from "../components/AuthLayout";

const ForgotPassword = () => {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await api.post("/auth/forgot-password", { email });
      setSuccess("Se o e-mail existir, você receberá instruções para redefinir sua senha.");
    } catch (err) {
      setSuccess("Se o e-mail existir, você receberá instruções para redefinir sua senha.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar Senha"
      subtitle="Informe seu e-mail para receber o link de redefinição"
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, color: "#fff" }}>
            <CircularProgress size={48} sx={{ color: "#fff" }} />
            <span>Enviando...</span>
          </div>
        </div>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {success}
        </Alert>
      )}

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <TextField
          label="E-mail"
          type="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          required
          InputLabelProps={{ shrink: true }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={loading}
          sx={{
            py: 1.5,
            fontSize: "1rem",
            borderRadius: 2,
            textTransform: "none",
            bgcolor: theme.palette.primary.main,
            "&:hover": {
              bgcolor: theme.palette.primary.dark,
            },
          }}
        >
          {loading ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <CircularProgress size={20} sx={{ color: "#fff" }} />
              Enviando...
            </span>
          ) : (
            "Enviar link"
          )}
        </Button>

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mt: 2 }}
        >
          <Typography
            component="span"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => (window.location.href = "/")}
          >
            Voltar para login
          </Typography>
        </Typography>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPassword;
